import { Controller, add } from "@hotwired/stimulus"
import TomSelect from "tom-select";

// Connects to data-controller="sales-order"
export default class extends Controller {
  static targets = ["shippingAddress", 'billingAddress', "componentField", "component", "hiddenItem", "removeComponent", "addComponent"]

  shipping_addresses = new TomSelect("#sales_order_shipping_address_id",{
    valueField: 'id',
    labelField: 'full_address',
    searchField: ['company_name', 'name', 'address_line_1', 'address_line_2', 'city', 'state_province', 'postal_code', 'country'],
    optgroupField: 'address_type',
    optgroups: [
      {value: 'warehouse', address_type: 'Warehouses'},
      {value: 'retailer', address_type: 'Retailers'},
      {value: 'customer', address_type: 'Customers'},
      {value: 'accounts_payable', address_type: 'Accounts Payables'},
    ],
    // fetch remote data
    load: function(query, callback) {
      let url = document.querySelector("#sales_order_shipping_address_id").dataset.dataUrl
      console.log('Loading....')
      console.log(url)
      if(query){
        url = url + '&query=' + encodeURIComponent(query);
      }
      fetch(url)
      .then(response => response.json())
      .then(json => {
        callback(json);
      }).catch(()=>{
        callback();
      });
    },
    create: function(input, _callback) {
      const newLink = document.querySelector("#add_new_shipping_address")
      if(newLink){
        newLink.click()
      }
    },
    render: {
      optgroup_header: function(data, escape) {
        return '<h3 class="text-primary optgroup-header sticky top-0">' + escape(data.address_type) +'</h3>';
      },
      option: function(data, escape) {
        return JSON.parse(data.full_address);
      },
      item: function(data, escape) {
        return JSON.parse(data.full_address);
      }
    }
  });

  connect(){
  }

  adjustShippingAddress(event){
    let url = document.querySelector("#sales_order_shipping_address_id").dataset.dataUrl
    const baseUrl = url.split('?')[0]
    url = baseUrl + `?retailer_id=${event.target.value}`
    document.querySelector("#sales_order_shipping_address_id").dataset.dataUrl = url
    this.shipping_addresses.clear()
    this.shipping_addresses.clearOptions()
    this.shipping_addresses.load()

    const baseNewUrl = document.querySelector('#add_new_shipping_address').href.split("?")[0]
    const new_url = baseNewUrl + `?address_type=shipping_address&retailer_id=${event.target.value}`
    document.querySelector('#add_new_shipping_address').href = new_url
  }

  validateAddress(event){
    const value = event.target.value
    const addressTag = event.target.dataset.addressTag
    const object = document.querySelector(addressTag)
    if(object){
      let url = new URL(object.src)
      let params = url.searchParams
      params.set('address_id', value)
      url.search = params.toString()
      object.src = url.toString()
    }
  }

  addComponentTargetConnected(element){
    const id = element.dataset.id
    const inforNumber = element.dataset.inforNumber
    const skuId = element.dataset.skuId
    const existingSelect = document.querySelector(`[data-starting-infor-number='${inforNumber}']`)

    if (existingSelect){
      const input = existingSelect.closest("tr").querySelector("[data-type='quantity']")
      input.closest("tr").style = null
      input.closest("tr").querySelector('input.destroy_field').value = false

      let newNum = parseInt(input.value)
      newNum++
      input.value = newNum
      input.dispatchEvent(new Event('input'));
      input.closest("tr").querySelector("input.sku_field").value = skuId
    }else{
      document.querySelector("#add-component-btn").click()
      const lastRow = document.querySelector("#components-list").querySelector("tr:last-child")
      const select = lastRow.querySelector("select")
      select.dataset.startingValue = id
      select.dataset.startingInforNumber = inforNumber
      lastRow.querySelector("input.sku_field").value = skuId
    }

    element.remove()
  }

  shippingAddressTargetConnected(element){
    const id = element.dataset.id
    const address = JSON.parse(element.dataset.address)
    this.shipping_addresses.removeOption(id)
    this.shipping_addresses.addOption({id: id, full_address: JSON.stringify(address)})
    this.shipping_addresses.setValue(id)
    element.remove()
  }

  removeComponentTargetConnected(element){
    const id = element.dataset.id
    const item = document.querySelector(`[data-value='${id}'].item`)
    if(item){
      item.closest("tr").querySelector('.destroy').click()
    }
  }

  checkComponentPredecessor(response){
    if (response && response.predecessor_with_inventory != "null"){
      const predecessor = JSON.parse(response.predecessor_with_inventory)
      const link = document.querySelector("#component_check")
      const url = link.dataset.url + `?component_id=${predecessor.id}&close=true&remove=${response.id}`
      link.href = url
      link.click()
    }
  }

  fetchLocations(event){
    this.locations.clearOptions();
    this.locations.load();
    this.locations.setValue(null)
    this.shipping_addresses.clearOptions();
    this.shipping_addresses.load();
    this.product_skus.clearOptions();
    this.product_skus.load();
    this.product_skus.setValue(null)
  }

  fetchComponentInfo(event){
    const url = event.target.dataset.componentUrl + ".json"
    const tr = event.target.closest('tr')
    const warehouse = document.querySelector("#part_order_warehouse_id")
    let newUrl = url
    if(event.target.value){
      newUrl = url + `?warehouse_id=${warehouse.value}&id=${event.target.value}`
    }

    fetch(newUrl)
      .then(response => response.json())
      .then(json => {
        tr.querySelector('.component_price').dataset.value = json.price
        tr.querySelector('.component_unit_cost').dataset.value = json.price
        tr.querySelector('.component_unit_cost').innerHTML = `$${json.price}`
        tr.querySelector('.component_inventory').innerHTML = JSON.parse(json.component_inventory)
        this.updateWarehouseTotals()
        this.calculateTotals()
        this.checkComponentPredecessor(json)
      }).catch(()=>{
        console.log("ERROR")
      });
    }

    updateTotal(){
      this.updateWarehouseTotals()
      this.calculateTotals()
    }

    updateWarehouseTotals(){
      document.querySelectorAll(".component_price").forEach(element => {
        let row = element.closest('tr')
        element.innerHTML = `$${this.getComponentTotalPrice(row).toFixed(2)}`
      })
    }

    getComponentTotalPrice(row){
      return parseFloat(row.querySelector("[data-type='quantity']").value * row.querySelector(".component_price").dataset.value)
    }

    calculateTotals(){
      let total = 0.0
      const serviceType = this.shipping_service.getValue()
      if(serviceType){
        let service = document.querySelector(`[data-service-type='${serviceType}']`)
        if (service){
          document.querySelector("#part_order_shipping_cost_estimate").value = service.dataset.price
          total += parseFloat(service.dataset.price)
        }
      }
      this.componentTargets.forEach(row => {
        if(row.style.display == 'none'){
        }else{
          total += this.getComponentTotalPrice(row)
        }
      });
      document.querySelector("#grand_total_price").innerHTML = `$${total.toFixed(2)}`
    }

    toggleHiddenItems(){
      this.hiddenItemTargets.forEach(ele => {
        ele.toggleAttribute("hidden")
      });
      document.querySelector("#grand_total_price").classList.toggle('line-through')
      document.querySelector("#grand_total_price").classList.toggle('text-secondary')
    }

    toggleShippingRates(){
      const shippingRates = document.querySelector("#shipping_service_field")
      const warehouse = document.querySelector("#part_order_warehouse_id")
      const option = warehouse.options[warehouse.selectedIndex].dataset.shipStation;
      console.log(option)
      if(option === 'true'){
        shippingRates.hidden = false
      }else{
        shippingRates.hidden = true
      }
    }

    getShippingRates(){
      if(this.shipping_service.getValue()){
        document.querySelector("#part_order_shipping_service").dataset.default = this.shipping_service.getValue()
      }
      const value = document.querySelector("#part_order_shipping_service").dataset.default
      this.shipping_service.setValue(null)
      this.shipping_service.clearOptions();
      this.shipping_service.load()
    }

    getAddressID(addressType, option){
      if(addressType == 'shipping_address'){
        return this.shipping_addresses.getValue()
      }
      if(addressType == 'location'){
        return option.dataset.addressId
      }
    }

    getOptionID(addressType){
      if(addressType == 'shipping_address'){
        return this.shipping_addresses.getValue()
      }
      if(addressType == 'location'){
        return this.locations.getValue()
      }
    }

    getAddressOption(addressType, id){
      if(addressType == 'shipping_address'){
        return this.shipping_addresses.getOption(id)
      }
      if(addressType == 'location'){
        return this.locations.getOption(id)
      }
    }

    billingAddressTargetConnected(element){
      const id = element.dataset.id
      const address = JSON.parse(element.dataset.address)
      this.billing_addresses.removeOption(id)
      this.billing_addresses.addOption({id: id, full_address: JSON.stringify(address)})
      this.billing_addresses.setValue(id)
      element.remove()
    }

}


